(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tiktok-video-feed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tiktok-feed-controller')) {
    class TikTokFeedController extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.mobile = window.matchMedia('(max-width: 767px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.hoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.slider = this.querySelector('slider-element');
        this.items = Array.from(this.querySelectorAll('[data-feed-player]')).map(element => ({
          element, button: element.querySelector('[data-feed-toggle]'),
          mode: 'auto', hovered: false, wanted: false, visible: false, request: 0
        }));
        const on = (target, name, fn, options = {}) => target.addEventListener(name, fn, { ...options, signal: this.events.signal });
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };
        this.items.forEach(item => {
          on(item.button, 'click', () => {
            item.mode = item.wanted ? 'pause' : 'play';
            if (item.mode === 'play') this.manualItem = item;
            this.update();
          });
          on(item.element, 'pointerenter', () => { item.hovered = true; this.schedule(); });
          on(item.element, 'pointerleave', () => { item.hovered = false; this.schedule(); });
          on(item.element, 'focusin', () => { item.hovered = true; this.schedule(); });
          on(item.element, 'focusout', event => {
            if (!item.element.contains(event.relatedTarget)) { item.hovered = false; this.schedule(); }
          });
        });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              const item = this.items.find(item => item.element === entry.target);
              if (item) item.visible = entry.isIntersecting;
            });
            this.schedule();
          }, { threshold: [0, 0.5, 1] });
          this.items.forEach(item => this.observer.observe(item.element));
        }
        on(window, 'scroll', this.schedule, { passive: true, capture: true });
        on(window, 'resize', this.schedule, { passive: true });
        on(document, 'visibilitychange', () => this.update());
        on(window, 'pagehide', () => { this.suspended = true; this.update(); });
        on(window, 'pageshow', () => { this.suspended = false; this.schedule(); });
        [this.mobile, this.reducedMotion, this.hoverDevice].forEach(query => on(query, 'change', this.schedule));
        if (navigator.connection) on(navigator.connection, 'change', this.schedule);
        this.schedule();
      }

      update() {
        if (!this.isConnected || !this.items) return;
        const slider = this.slider.getBoundingClientRect();
        const center = (Math.max(0, slider.left) + Math.min(innerWidth, slider.right)) / 2;
        const connection = navigator.connection;
        const allowAuto = !this.reducedMotion.matches && !connection?.saveData && !/2g/.test(connection?.effectiveType || '');
        const visible = this.items.filter(item => {
          const box = item.element.getBoundingClientRect();
          const width = Math.max(0, Math.min(box.right, slider.right, innerWidth) - Math.max(box.left, slider.left, 0));
          const height = Math.max(0, Math.min(box.bottom, slider.bottom, innerHeight) - Math.max(box.top, slider.top, 0));
          item.distance = Math.abs((box.left + box.right) / 2 - center);
          return (item.visible || !this.observer) && box.width > 0 && box.height > 0 && width * height / (box.width * box.height) >= 0.5;
        });
        const current = visible.includes(this.manualItem) && this.manualItem.mode === 'play'
          ? this.manualItem : visible.reduce((best, item) => !best || item.distance < best.distance ? item : best, null);
        const desired = this.items.map(item => {
          const auto = allowAuto && item.element.dataset.autoplay === 'true'
            && (item.element.dataset.hover !== 'true' || !this.hoverDevice.matches || item.hovered);
          return !document.hidden && !this.suspended && visible.includes(item)
            && (!this.mobile.matches || item === current)
            && (item.mode === 'play' || (item.mode === 'auto' && auto));
        });
        this.items.forEach((item, index) => { if (!desired[index]) this.setPlayback(item, false); });
        this.items.forEach((item, index) => { if (desired[index]) this.setPlayback(item, true); });
      }

      setPlayback(item, wanted) {
        if (item.wanted === wanted) return;
        item.wanted = wanted;
        const request = ++item.request;
        item.button.setAttribute('aria-pressed', String(wanted));
        if (!wanted) {
          item.video?.pause();
          return;
        }
        if (!item.video) {
          const template = item.element.querySelector('template');
          const fragment = document.createRange().createContextualFragment(template.innerHTML);
          const video = fragment.querySelector('video');
          video.muted = true;
          video.playsInline = true;
          video.removeAttribute('autoplay');
          video.addEventListener('playing', () => {
            if (!item.wanted || document.hidden || !this.isConnected) { video.pause(); return; }
            item.element.setAttribute('data-playing', '');
          });
          video.addEventListener('pause', () => item.element.removeAttribute('data-playing'));
          video.addEventListener('ended', () => {
            item.mode = 'pause';
            this.setPlayback(item, false);
          });
          video.addEventListener('error', () => {
            item.mode = 'pause';
            item.failed = true;
            this.setPlayback(item, false);
            item.element.removeAttribute('data-playing');
          });
          template.after(fragment);
          item.video = video;
        }
        if (item.failed) { item.failed = false; item.video.load(); }
        Promise.resolve(item.video.play()).then(() => {
          if (!item.wanted || !this.isConnected) item.video.pause();
        }).catch(() => {
          if (item.request !== request) return;
          item.mode = 'pause';
          this.setPlayback(item, false);
        });
      }

      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.items?.forEach(item => {
          this.setPlayback(item, false);
          if (item.video) {
            item.video.removeAttribute('src');
            item.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
            item.video.load();
            item.video.remove();
          }
        });
        this.manualItem = null;
      }
    }
    customElements.define('tiktok-feed-controller', TikTokFeedController);
  }

  } catch(e) { console.error(e); }
})();
})();
